<template>
<div class="swaychat-lightbox" v-if="previewImg" @click="togglePreview">
  <div class="swaychat-loading-circle"></div>
  <div class="swaychat-lightbox-target" @click.prevent="viewImage()">
    <img :src="makeAliasHost(previewImg) + '/-/progressive/yes/-/preview/'" style="display:none" alt="" onload="this.style.display = ''" class="swaychat-bounceIn">
  </div>
</div>
</template>

<script>

export default {
  updated() {
    if (this.previewImg)
      window.addEventListener('keyup', this.togglePreview)
    else
      window.removeEventListener('keyup', this.togglePreview)
  },
  computed: {
    previewImg() {
      return this.$store.getters.getPreview
    }
  },
  methods: {
    togglePreview() {
      this.$store.commit('setPreviewImg', null)
    },
    viewImage() {
      window.open(this.previewImg,'_blank')
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }
}

</script>
